(function ($) {
  let filterMoreButton = false;

  var ss = {
    init: function () {
      this.showPopup();
      this.hidePopup();
      this.hidePu();
      this.initaddjs();
      this.btnAddtocart();
      this.initAddToCart();
      this.initSwatch();
      this.initDropDownCart();
      this.initToolsCart();
      this.initProductAddToCart();
      this.initlOwlCarousel();
      this.reviewsSlider();
      this.sellWatchsForm();
      this.initFilters();
      this.initAutoSearch();
    },
    initlOwlCarousel: function () {
      $(".ss-owl .owl-carousel").each(function () {
        var owlCarousel = $(this);
        var nav = owlCarousel.data("nav"),
          dots = owlCarousel.data("dots"),
          autoplay = owlCarousel.data("autoplay"),
          autoplaytimeout = owlCarousel.data("autoplaytimeout"),
          rewind = owlCarousel.data("rewind"),
          speed = owlCarousel.data("speed"),
          column0 = owlCarousel.data("column0"),
          column1 = owlCarousel.data("column1"),
          column2 = owlCarousel.data("column2"),
          column3 = owlCarousel.data("column3"),
          column4 = owlCarousel.data("column4"),
          column5 = owlCarousel.data("column5"),
          margin = owlCarousel.data("margin"),
          lazyLoad = owlCarousel.data("lazyLoad"),
          rtl = owlCarousel.data("rtl"),
          mobile = owlCarousel.data("mobile");

        if (column0 === undefined) {
          column0 = 1;
        }

        var config = {
          nav: nav,
          navElement: "div",
          dots: dots,
          margin: margin,
          rewind: rewind,
          autoplay: autoplay,
          autoplayTimeout: autoplaytimeout,
          speed: speed,
          loop: false,
          addClassActive: true,
          lazyLoad: lazyLoad,
          rtl: rtl,
          navText: ['<i class="icon-left"></i>', '<i class="icon-right"></i>'],
          navClass: ["owl-prev", "owl-next"],
          afterAction: FirstLastActiveItem,
          onInitialized: updateHeight,
          responsive: {
            0: {
              items: column0,
              margin: 10,
            },
            321: {
              items: column5,
              margin: 10,
            },
            567: {
              items: column4,
              margin: 16,
            },
            767: {
              items: column3,
              margin: 16,
            },
            991: {
              items: column2,
              nav: nav,
            },
            1199: {
              items: column1,
              nav: nav,
            },
          },
        };
        owlCarousel.owlCarousel(config);
        function FirstLastActiveItem(el) {
          el.find(".owl-item").removeClass("first");
          el.find(".owl-item.active").first().addClass("first");
          el.find(".owl-item").removeClass("last");
          el.find(".owl-item.active").last().addClass("last");
        }

        if (mobile === false && innerWidth < 768) {
          owlCarousel.owlCarousel("destroy");
        }

        function updateHeight() {
          if (
            owlCarousel.hasClass("featured-products__slider") &&
            !owlCarousel.hasClass("featured-collections__slider")
          ) {
            owlCarousel.find(".owl-stage").css("display", "flex");
          }
        }
      });
    },
    initDropDownCart: function (show) {
      if ($(".mini-products-list li").length > 0) {
        $(".minicart-header .block-content .no-items").hide();
        $(".minicart-header .block-content .has-items").show();
      } else {
        $(".minicart-header .block-content .has-items").hide();
        $(".minicart-header .block-content .no-items").show();
      }

      $(document).on("click", ".minicart-header .btn-remove", function (event) {
        event.preventDefault();
        var productId = $(this).parents(".item").data("product_id");
        Shopify.removeItem(productId, function (cart) {
          ss.doUpdateDropdownCart(cart, false);
          ss.doUpdateToolsCart(cart);
        });
      });

      setTimeout(() => {
        if (show) {
          $(".minicart-header .dropdown-content")
            .stop()
            .slideDown(0)
            .addClass("is-active");
        }
      }, 500);

      $(".dropdown-content__overlay").on("click", function (e) {
        $(".minicart-header .dropdown-content")
          .stop()
          .slideUp(0)
          .removeClass("is-active");
      });
    },
    initToolsCart: function () {
      if ($(".popup-mycart .cart-header table.list-cart tbody tr").length > 0) {
        $(".popup-mycart .cart-header .no-items").hide();
        $(".popup-mycart .cart-header .has-items").show();
      } else {
        $(".popup-mycart .cart-header .has-items").hide();
        $(".popup-mycart .cart-header .no-items").show();
      }

      $(document).on(
        "click",
        ".so-groups-sticky .popup-mycart .btn-remove",
        function (event) {
          event.preventDefault();
          var productId = $(this).data("productid");
          Shopify.removeItem(productId, function (cart) {
            ss.doUpdateToolsCart(cart);
            ss.doUpdateDropdownCart(cart);
          });
        }
      );
    },
    doUpdateDropdownCart: function (cart, adding) {
      var template = '<li class="item" data-product_id="{ID}">';
      template += '<div class="product-img-wrap">';
      template += '<a href="{URL}" title="{TITLE}" class="product-image">';
      template += '<img src="{IMAGE}" alt="{TITLE}">';
      template += "</a>";
      template +=
        '<a href="javascript:void(0)"  title="Remove This Item" class="btn-remove"></a>';
      template += "</div>";
      template += '<div class="product-details">';
      template += '<div class="inner-left">';
      template += '<h3 class="product-name">';
      template += `<a href="{URL}">{BRAND}</a>`;
      template += "</h3>";
      template += '<p class="item_description">{TITLE}</p>';
      template += '<div class="product-details-bottom">';
      template += "<strong>{QUANTITY}</strong>";
      template += '<span class="title-desc">{ITEMCOUNT}</span>';
      template += "</div>";
      template += "</div>";
      template += '<div class="product-price">';
      template += '<span class="price">{PRICE}</span>';
      template += "</div>";
      template += "</li>";
      let brands = [];

      for (let n = 0; n <= $(".mini-products-list .item").length; n++) {
        brands.push({
          brand: $(".mini-products-list .item")
            .eq(n)
            .find(".product-name a")
            .text(),
          title: $(".item_description").eq(n).text(),
        });
      }

      $("#CartCount").text(cart.item_count);
      $(".minicart-header #CartTotal .money").html(
        Shopify.formatMoney(cart.total_price, window.money_format)
      );
      $(".minicart-header .price-total .price .money").html(
        Shopify.formatMoney(cart.total_price, window.money_format)
      );
      $(".price-total-w .price-total .price").html(
        Shopify.formatMoney(cart.total_price, window.money_format)
      );
      $(".minicart-header .mini-products-list").html("");
      if (cart.item_count > 0) {
        for (var i = 0; i < cart.items.length; i++) {
          var item = template;
          var longDecription = cart.items[i].product_description;
          if (cart.items[i].quantity > 1) {
            var itemWord = " Items";
          } else {
            var itemWord = " Item";
          }
          let currentTitle = cart.items[i].title;
          item = item.replace(/\{ID\}/g, cart.items[i].id);
          item = item.replace(/\{URL\}/g, cart.items[i].url);
          item = item.replace(/\{TITLE\}/g, cart.items[i].title);
          item = item.replace(/\{QUANTITY\}/g, cart.items[i].quantity);
          item = item.replace(/\{ITEMCOUNT\}/g, itemWord);
          item = item.replace(
            /\{IMAGE\}/g,
            Shopify.resizeImage(cart.items[i].image, "small")
          );
          item = item.replace(
            /\{PRICE\}/g,
            Shopify.formatMoney(cart.items[i].price, window.money_format)
          );

          if (adding) {
            if (i === 0) {
              if ($(".product-single__collection").length > 0) {
                item = item.replace(
                  /\{BRAND\}/g,
                  $(".product-single__collection").text()
                );
              } else {
                let brandName;

                $(".product-item").each((i, e) => {
                  if ($(e).find(".product-name") !== undefined) {
                    if (
                      $(e).find(".product-name").text().slice(0, 39) ===
                      currentTitle.slice(0, 39)
                    ) {
                      brandName = $(e).find(".brand-name").text();
                    }
                  } else {
                    if (
                      $(e).find(".title-product").text().slice(0, 39) ===
                      currentTitle.slice(0, 39)
                    ) {
                      brandName = $(e).find(".brand-name").text();
                    }
                  }
                });

                item = item.replace(/\{BRAND\}/g, brandName);
              }
            } else {
              item = item.replace(/\{BRAND\}/g, brands[i - 1].brand);
            }
          } else {
            for (let m = 0; m < brands.length; m++) {
              if (cart.items[i].title === brands[m].title) {
                item = item.replace(/\{BRAND\}/g, brands[m].brand);
              }
            }
          }

          $(".minicart-header .mini-products-list").append(item);
        }
        $(".minicart-header .btn-remove").click(function (event) {
          event.preventDefault();
          var productId = $(this).parents(".item").data("product_id");
          Shopify.removeItem(productId, function (cart) {
            ss.doUpdateDropdownCart(cart);
          });
        });

        if (ss.ConvertCurrency()) {
          Currency.convertAll(
            window.shop_currency,
            jQuery("select[name=currencies] option:selected").val(),
            ".minicart-header span.money",
            "money_format"
          );
        }
      }
      if ($(".mini-products-list li").length > 0) {
        $(".minicart-header .block-content .no-items").hide();
        $(".minicart-header .block-content .has-items").show();
      } else {
        $(".minicart-header .block-content .has-items").hide();
        $(".minicart-header .block-content .no-items").show();
      }
    },
    initSwatch: function () {
      jQuery(".swatch :radio").change(function () {
        var optionIndex = jQuery(this)
          .closest(".swatch")
          .attr("data-option-index");
        var optionValue = jQuery(this).val();
        jQuery(this)
          .closest("form")
          .find(".single-option-selector")
          .eq(optionIndex)
          .val(optionValue)
          .trigger("change");
      });
      Shopify.optionsMap = {};

      Shopify.updateOptionsInSelector = function (selectorIndex) {
        switch (selectorIndex) {
          case 0:
            var key = "root";
            var selector = $(".single-option-selector:eq(0)");
            break;
          case 1:
            var key = $(".single-option-selector:eq(0)").val();
            var selector = $(".single-option-selector:eq(1)");
            break;
          case 2:
            var key = $(".single-option-selector:eq(0)").val();
            key += " / " + $(".single-option-selector:eq(1)").val();
            var selector = $(".single-option-selector:eq(2)");
        }

        var initialValue = selector.val();
        selector.empty();
        var availableOptions = Shopify.optionsMap[key];
        if (availableOptions && availableOptions.length) {
          for (var i = 0; i < availableOptions.length; i++) {
            var option = availableOptions[i];
            var newOption = $("<option></option>").val(option).html(option);
            selector.append(newOption);
          }
          $(
            '.swatch[data-option-index="' + selectorIndex + '"] .swatch-element'
          ).each(function () {
            if (
              $.inArray($(this).attr("data-value"), availableOptions) !== -1
            ) {
              $(this)
                .removeClass("soldout")
                .show()
                .find(":radio")
                .removeAttr("disabled", "disabled")
                .removeAttr("checked");
            } else {
              $(this)
                .addClass("soldout")
                .hide()
                .find(":radio")
                .removeAttr("checked")
                .attr("disabled", "disabled");
            }
          });
          if ($.inArray(initialValue, availableOptions) !== -1) {
            selector.val(initialValue);
          }
          selector.trigger("change");
        }
      };
      Shopify.linkOptionSelectors = function (product) {
        // Building our mapping object.
        for (var i = 0; i < product.variants.length; i++) {
          var variant = product.variants[i];
          if (variant.available) {
            // Gathering values for the 1st drop-down.
            Shopify.optionsMap["root"] = Shopify.optionsMap["root"] || [];
            Shopify.optionsMap["root"].push(variant.option1);
            Shopify.optionsMap["root"] = Shopify.uniq(
              Shopify.optionsMap["root"]
            );
            // Gathering values for the 2nd drop-down.
            if (product.options.length > 1) {
              var key = variant.option1;
              Shopify.optionsMap[key] = Shopify.optionsMap[key] || [];
              Shopify.optionsMap[key].push(variant.option2);
              Shopify.optionsMap[key] = Shopify.uniq(Shopify.optionsMap[key]);
            }
            // Gathering values for the 3rd drop-down.
            if (product.options.length === 3) {
              var key = variant.option1 + " / " + variant.option2;
              Shopify.optionsMap[key] = Shopify.optionsMap[key] || [];
              Shopify.optionsMap[key].push(variant.option3);
              Shopify.optionsMap[key] = Shopify.uniq(Shopify.optionsMap[key]);
            }
          }
        }
        // Update options right away.
        Shopify.updateOptionsInSelector(0);
        if (product.options.length > 1) Shopify.updateOptionsInSelector(1);
        if (product.options.length === 3) Shopify.updateOptionsInSelector(2);
        // When there is an update in the first dropdown.
        $(".single-option-selector:eq(0)").change(function () {
          Shopify.updateOptionsInSelector(1);
          if (product.options.length === 3) Shopify.updateOptionsInSelector(2);
          return true;
        });
        // When there is an update in the second dropdown.
        $(".single-option-selector:eq(1)").change(function () {
          if (product.options.length === 3) Shopify.updateOptionsInSelector(2);
          return true;
        });
      };
    },
    showLoading: function () {
      $(".ss-loading").show();
    },
    hideLoading: function () {
      $(".ss-loading").hide();
    },
    showPopup: function (selector) {
      $(selector).addClass("active");
    },
    hidePopup: function (selector) {
      $(selector).removeClass("active");
    },
    hidePu: function () {
      $(document).on(
        "click",
        ".popup_bg",
        ".overlay, .close-popup",
        function () {
          ss.hidePopup(".modal-pu");
          setTimeout(function () {
            $(".loading").removeClass("loaded-content");
          }, 500);

          return false;
        }
      );
      $(document).on("click touchstart", function (e) {
        var dropdown = $(".modal-pu");
        if (!dropdown.is(e.target) && dropdown.has(e.target).length === 0) {
          dropdown.removeClass("active");
        }
      });

      $(".close-pu").click(function () {
        $(".modal-pu").removeClass("active");
        return false;
      });
    },
    initProductAddToCart: function () {
      if ($("#AddToCart-product-template").length > 0) {
        $("#AddToCart-product-template").click(function (event) {
          event.preventDefault();
          if ($(this).attr("disabled") != "disabled") {
            var variant_id = $("form.product-form select[name=id]").val();
            if (!variant_id) {
              variant_id = $("form.product-form input[name=id]").val();
            }
            var quantity = $("form.product-form input[name=quantity]").val();
            if (!quantity) {
              quantity = 1;
            }
            var title = $("h1.product-single__title").html();
            var image = $(".product-featured-img").attr("src");
            ss.doAjaxAddToCart(variant_id, quantity, title, image);
          }
          return false;
        });
      }
    },
    initAddToCart: function () {
      $(document).on("click", ".product-item .btn-addToCart", function (event) {
        event.preventDefault();
        if ($(this).attr("disabled") != "disabled") {
          var productItem = $(this).closest(".product-item");
          var productId = $(this).closest(".product-item").data("id");
          productId = productId.replace("product-", "");

          var variant_id = $(this).parent("form").find("select[name=id]").val();
          if (!variant_id) {
            variant_id = $(this).parent("form").find("input[name=id]").val();
          }

          var quantity = $(this)
            .parent("form")
            .find("input[name=quantity]")
            .val();
          if (!quantity) {
            quantity = 1;
          }

          var title = $(productItem).find(".product-name").html();
          var image = $(productItem).find(".image-ajax img").attr("src");

          ss.doAjaxAddToCart(variant_id, quantity, title, image);
        }

        return false;
      });
    },
    btnAddtocart: function () {
      $(window.btn_addToCart).click(function (event) {
        event.preventDefault();
        if ($(this).attr("disabled") != "disabled") {
          var variant_id = $(
            window.product_detail_form + " select[name=id]"
          ).val();
          if (!variant_id) {
            variant_id = $(
              window.product_detail_form + " input[name=id]"
            ).val();
          }
          var quantity = $(
            window.product_detail_form + " input[name=quantity]"
          ).val();
          if (!quantity) {
            quantity = 1;
          }
          var title = $(window.product_detail_name).html();
          var image = $(window.product_detail_mainImg).attr("src");
          ss.doAjaxAddToCart(variant_id, quantity, title, image);
        }

        return false;
      });
    },
    doAjaxAddToCart: function (variant_id, quantity, title, image) {
      $.ajax({
        type: "post",
        url: "/cart/add.js",
        data: "quantity=" + quantity + "&id=" + variant_id,
        dataType: "json",
        beforeSend: function () {
          ss.showLoading(".ss-loading");
          if (window.theme_load == "icon") {
            ss.showLoading(".btn-addToCart");
          } else {
            ss.showPopup(".loading");
          }
        },
        success: function (msg) {
          ss.hideLoading(".ss-loading");
          if (window.theme_load == "icon") {
            ss.hideLoading(".btn-addToCart");
          } else {
            $(".loading").addClass("loaded-content");
          }

          switch (window.addcart_susscess) {
            case "popup":
              ss.initDropDownCart(true);
              break;

            case "text":
              ss.hidePopup(".loading");
              ss.hideLoading(".btn-addToCart");
              break;

            case "noitice":
              ss.hidePopup(".loading");
              ss.hideLoading(".btn-addToCart");
              $(".product-noitice.susscess").find(".product-name").html(title);
              $(".product-noitice.susscess")
                .find(".product-image img")
                .attr("src", image);
              ss.showNoitice(".product-noitice.susscess");
              break;

            default:
              break;
          }

          ss.updateMiniCart(true);
          ss.updateToolsCart();
        },
        error: function (xhr, text) {
          ss.hidePopup(".loading");
          ss.hideLoading(".ss-loading");
          $(".error-message")
            .text($.parseJSON(xhr.responseText).description)
            .fadeIn();

          setTimeout(() => {
            $(".error-message").fadeOut();
          }, 2000);
        },
      });
    },
    updateMiniCart: function (adding) {
      Shopify.getCart(function (cart) {
        if (adding) {
          ss.doUpdateDropdownCart(cart, true);
        } else {
          ss.doUpdateDropdownCart(cart);
        }
      });
    },
    updateToolsCart: function () {
      Shopify.getCart(function (cart) {
        ss.doUpdateToolsCart(cart);
      });
    },
    doUpdateToolsCart: function (cart) {
      var template = "";
      template += "<tr>";
      template +=
        '<td class="text-left first"><a href="{URL}"><img class="img-thumbnail img-responsive" src="{IMAGE}" alt="{TITLE}" /></a></td>';
      template += '<td class="text-left"><a href="{URL}">{TITLE}</a></td>';
      template += '<td class="text-right">x&nbsp;{QUANTITY}</td>';
      template += '<td class="text-right total-price">{PRICE}</td>';
      template +=
        '<td class="text-right last"><a href="javascript:;" data-productid="{ID}" return false;" class="btn-remove"><i class="fa fa-trash"></i></a></td>';
      template += "</tr>";

      $("#scartcount").text(cart.item_count);
      $(".popup-mycart .cart-header .cart-bottom table tr td span.money").html(
        Shopify.formatMoney(cart.total_price, window.money_format)
      );
      $(".popup-mycart .cart-header .cart-bottom table tr td span.money").attr(
        "data-currency-usd",
        Shopify.formatMoney(cart.total_price, window.money_format)
      );
      $(".popup-mycart .cart-header table.list-cart tbody").html("");

      if (cart.item_count > 0) {
        for (var i = 0; i < cart.items.length; i++) {
          var item = template;
          item = item.replace(/\{ID\}/g, cart.items[i].id);
          item = item.replace(/\{URL\}/g, cart.items[i].url);
          item = item.replace(/\{TITLE\}/g, cart.items[i].title);
          item = item.replace(/\{QUANTITY\}/g, cart.items[i].quantity);
          item = item.replace(
            /\{IMAGE\}/g,
            Shopify.resizeImage(cart.items[i].image, "80x80")
          );
          item = item.replace(
            /\{PRICE\}/g,
            Shopify.formatMoney(cart.items[i].price, window.money_format)
          );
          $(".popup-mycart .cart-header table.list-cart tbody").append(item);
        }

        $(document).on(
          "click",
          ".so-groups-sticky .popup-mycart .btn-remove",
          function (event) {
            event.preventDefault();
            var productId = $(this).data("productid");
            Shopify.removeItem(productId, function (cart) {
              ss.doUpdateToolsCart(cart);
            });
          }
        );

        if (ss.ConvertCurrency()) {
          Currency.convertAll(
            window.shop_currency,
            jQuery("select[name=currencies] option:selected").val(),
            ".so-groups-sticky span.money",
            "money_format"
          );
        }
      }

      if ($(".popup-mycart .cart-header table.list-cart tbody tr").length > 0) {
        $(".popup-mycart .cart-header .no-items").hide();
        $(".popup-mycart .cart-header .has-items").show();
      } else {
        $(".popup-mycart .cart-header .has-items").hide();
        $(".popup-mycart .cart-header .no-items").show();
      }
    },
    convertToSlug: function (text) {
      return text
        .toLowerCase()
        .replace(/[^a-z0-9 -]/g, "")
        .replace(/\s+/g, "-")
        .replace(/-+/g, "-");
    },
    switchImage: function (src, imgObject, el) {
      var $el = $(el);
      $el.attr("src", src);
    },
    initaddjs: function () {
      const windowWidth =
        window.innerWidth || document.documentElement.clientWidth;
      $(".filter-category a").on("click", function () {
        var number = $(this).find("span").html();
        $(".product-count").text(number + " products");
      });
      $(".dropdown-toggle").on("click", function (e) {
        $(".dropdown-content").stop().slideUp(300).removeClass("active");
        $(this).next().stop().slideToggle(300);
        e.preventDefault();

        if (
          $(this).parent().hasClass("minicart-header") &&
          !$(".minicart-header .dropdown-content").hasClass("is-active")
        ) {
          $(".minicart-header .dropdown-content").addClass("is-active");
        }
      });
      // $('.dropdown-content li').on("click", function (e) {
      //   $(this).parent().slideUp(300);
      // });

      //PRODUCT TAB
      $(".ltabs-tabs-container").each(function () {
        $(this).find(".tabs-title li:first-child").addClass("current");
        $(this).find(".tab-content").first().addClass("current");

        $(this)
          .find(".tabs-title li")
          .click(function (e) {
            var tab_id = $(this).attr("data-tab");
            var url = $(this).attr("data-url");
            $(this)
              .closest(".ltabs-tabs-container")
              .find(".tab-viewall")
              .attr("href", url);

            $(this)
              .closest(".ltabs-tabs-container")
              .find(".tabs-title li")
              .removeClass("current");
            $(this)
              .closest(".ltabs-tabs-container")
              .find(".tab-content")
              .removeClass("current");

            $(this).addClass("current");
            $(this)
              .closest(".ltabs-tabs-container")
              .find("#" + tab_id)
              .addClass("current");
            e.preventDefault();
          });
      });
      $(".tabs-menu_btn").click(function (e) {
        e.preventDefault();
        $(".tabs-title").toggleClass("tabs-open");
      });
      //VERTICAL MENU

      $(".toggle-menu > a").click(function (e) {
        e.preventDefault();
        $(this).next().slideToggle("fast");
        $(this).children().children().toggleClass("show");
        return false;
      });

      $("#goToTop").addClass("hidden-top");
      $(window).scroll(function () {
        if ($(this).scrollTop() === 0) {
          $("#goToTop").addClass("hidden-top");
        } else {
          $("#goToTop").removeClass("hidden-top");
        }
      });

      $("#goToTop").click(function () {
        $("body,html").animate({ scrollTop: 0 }, 1200);
        return false;
      });

      // Remove Loading Overlay
      $("#loadingSite").fadeOut("slow");

      //GALLERY PRODUCT
      $(".product-card__gallery .item-img").on(
        "mouseover touchstart",
        function (e) {
          $(this)
            .addClass("thumb-active")
            .siblings()
            .removeClass("thumb-active");
          var thumb_src = $(this).attr("data-src");
          $(this)
            .closest(".product-item-container")
            .find(".img-responsive.s-img")
            .attr("src", thumb_src);
        }
      );
      //FOOTER MOBILE
      $(".collapsed-block .expander").click(function (e) {
        var collapse_content_selector = $(this).parent().next();
        var expander = $(this).parent();

        if (!$(collapse_content_selector).hasClass("open")) {
          expander.addClass("open");
        } else expander.removeClass("open");

        if (!$(collapse_content_selector).hasClass("open"))
          $(collapse_content_selector).addClass("open").slideDown("normal");
        else $(collapse_content_selector).removeClass("open").slideUp("normal");
        e.preventDefault();
      });

      //VERTICAL MENU
      $("#show-verticalmenu").click(function (e) {
        e.preventDefault();
        $(".vertical-wrapper").toggleClass("vertical-open");
        $(".vertical-screen").addClass("vertical-open");
      });

      $(".close-vertical").click(function (e) {
        e.preventDefault();
        $(".vertical-screen").removeClass("vertical-open");
        $(".vertical-wrapper").removeClass("vertical-open");
      });

      $(".vertical-screen").click(function (e) {
        e.preventDefault();
        $(this).toggleClass("vertical-open");
        $(".vertical-wrapper").removeClass("vertical-open");
      });

      //OFFCANVAS MENU
      $(".mob-menu").click(function (e) {
        e.preventDefault();
        $(".brands-submenu-wrapper--mob").addClass("submenu-open");
        $(".mobile-menu").toggleClass("nav-open");
        $(".mobile-screen").addClass("nav-open");
      });

      $(".mobile-screen").click(function (e) {
        e.preventDefault();
        $(".brands-submenu-wrapper--mob").addClass("submenu-open");
        $(this).toggleClass("nav-open");
        $(".mobile-menu").removeClass("nav-open");
      });

      $(".menu-remove").click(function (e) {
        e.preventDefault();
        $(".mobile-screen").removeClass("nav-open");
        $(".mobile-menu").removeClass("nav-open");
      });
      $(".mobile-menu__close-btn").click(function (e) {
        e.preventDefault();
        $(".brands-submenu-wrapper--mob").addClass("submenu-open");
        $(".mobile-screen").removeClass("nav-open");
        $(".mobile-menu").removeClass("nav-open");
      });
      //BONUS PAGE
      $("ul.yt-accordion li").each(function () {
        if ($(this).index() > 0) {
          $(".yt-accordion-inner").hide();
          $(".enable+.yt-accordion-inner").show();
          $(".enable+.yt-accordion-inner").addClass("active");
        } else {
          $(".enable").addClass("active");
        }

        var ua = navigator.userAgent,
          event = ua.match(/iPad/i) ? "touchstart" : "click";
        $(this)
          .children(".accordion-heading")
          .bind(event, function () {
            if ($(this).hasClass("active")) {
              $(this).removeClass("active");
              $(this).siblings(".yt-accordion-inner").removeClass("active");
              $(this).siblings(".yt-accordion-inner").slideUp(350);
            } else {
              $(this).addClass("active");
              $(this).siblings(".yt-accordion-inner").addClass("active");
              $(this).siblings(".yt-accordion-inner").slideDown(350);
            }

            $(this)
              .parent()
              .siblings("li")
              .children(".yt-accordion-inner")
              .slideUp(350);
            $(this)
              .parent()
              .siblings("li")
              .find(".active")
              .removeClass("active");
          });
      });
    },
    ConvertCurrency: function () {
      return (
        window.show_multiple_currencies &&
        Currency.currentCurrency != window.shop_currency
      );
    },
    reviewsSlider: function () {
      const $reviewsSlider = $(".reviews__items");

      if ($reviewsSlider.length) {
        const reviewsLength = $(".reviews__item").length;
        const sliderAutoplay = $reviewsSlider.data("autoplay");

        $reviewsSlider.slick({
          infinite: true,
          slidesToShow: 3,
          slidesToScroll: 1,
          autoplay: sliderAutoplay,
          dots: false,
          arrows: true,
          responsive: [
            {
              breakpoint: 991,
              settings: {
                slidesToShow: 2,
              },
            },
            {
              breakpoint: 767,
              settings: {
                slidesToShow: 1,
              },
            },
          ],
        });
      }
    },
    sellWatchsForm: function () {
      $("#get-image").on("change", (e) => {
        let html = "";

        for (let i = 0; i < e.target.files.length; i++) {
          let str = e.target.files[i].name;

          if (str.length > 20) {
            str = str.substr(0, 20) + "...";
          }

          html += `${str}<br>`;
        }

        $(".sell-or-trade__file-name span").html(html);
        $(".sell-or-trade__dropzone__label").hide();
        $(".sell-or-trade__file-name").show();
      });

      $(".sell-or-trade__file-name button").on("click", (e) => {
        e.preventDefault();
        $("#get-image").val("");
        $(".sell-or-trade__dropzone__label").show();
        $(".sell-or-trade__file-name").hide();
      });
    },
    filtersRaf: function () {
      if ($(document).find(".js-show-filters").length < 1) {
        let text = "More refinements";

        if (filterMoreButton === true) {
          text = "Less refinements";
        }

        $(document).find(".snize-filters-sidebar").append(`
          <a href="javascript:void(0)" class="js-show-filters" style="display: none">${text}</a>
        `);

        if ($('body').hasClass('snize-results-page')) {
          $('<div id="sidebar-Overlay" class="sidebar__overlay"></div>').insertAfter(".snize-filters-sidebar");

          $(document).find(".snize-filters-sidebar").prepend(`
            <h4 class="filter-refinded-title">
              <span>FILTER</span>
              <span id="close-sidebar-filter">
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12 4L4 12M4 4L12 12" stroke="#111322" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </span>
            </h4>
          `);

          $(document).find(".snize-horizontal-filters").prepend(`
            <h4 class="filter-title">
              <span>FILTER</span>
              <span>
                <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M3.5 8.5L15.5 8.5M15.5 8.5C15.5 10.1569 16.8431 11.5 18.5 11.5C20.1569 11.5 21.5 10.1569 21.5 8.5C21.5 6.84315 20.1569 5.5 18.5 5.5C16.8431 5.5 15.5 6.84315 15.5 8.5ZM9.5 16.5L21.5 16.5M9.5 16.5C9.5 18.1569 8.15685 19.5 6.5 19.5C4.84315 19.5 3.5 18.1569 3.5 16.5C3.5 14.8431 4.84315 13.5 6.5 13.5C8.15685 13.5 9.5 14.8431 9.5 16.5Z" stroke="#0E101B" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </span>
            </h4>
          `);
          $(document).find(".snize-main-panel-mobile-filters a").append(`
            <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M2 5.83334L10 5.83334M10 5.83334C10 6.93791 10.8954 7.83334 12 7.83334C13.1046 7.83334 14 6.93791 14 5.83334C14 4.72877 13.1046 3.83334 12 3.83334C10.8954 3.83334 10 4.72877 10 5.83334ZM6 11.1667L14 11.1667M6 11.1667C6 12.2712 5.10457 13.1667 4 13.1667C2.89543 13.1667 2 12.2712 2 11.1667C2 10.0621 2.89543 9.16668 4 9.16668C5.10457 9.16668 6 10.0621 6 11.1667Z" stroke="#0E101B" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          `);

          const newContent = `
            <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M6 9.5L12 15.5L18 9.5" stroke="#0E101B" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
            </svg>
          `;

          // Replace all elements matching the selector with the SVG
          $(".snize-filters-dropdown-title .caret").replaceWith(newContent);

          $(document).find(".snize-product-filter-opener").each(function () {
            $(this).append(`
              <span class="snize-selected-filter-values snize-arrow-wrapper">
                <span class="snize-back-arrow"></span>
              </span>
            `);
          });

          $(document).find("#snize_filters_dropdown_price li .snize-price-range").prepend(`
            <h4 class="price-filter-title">PRICE</h4>
          `);

          $(document).find(".snize-main-panel-dropdown-button").prepend(`
            <span>Sort by&nbsp;</span>
          `);

          $(document).find(".snize-main-panel-dropdown-button .caret").append(`
            <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M6.5 9.5L12.5 15.5L18.5 9.5" stroke="#0E101B" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          `);

          $(".snize-filters-sidebar").addClass("sidebar-drawer-design");

          $(".filter-title").click(function(){
            $(".snize-filters-sidebar").toggleClass("show-sidebar");
          });
          $("#sidebar-Overlay").click(function(){
            $(".snize-filters-sidebar").toggleClass("show-sidebar");
          });
          $("#close-sidebar-filter").click(function(){
            $(".snize-filters-sidebar").toggleClass("show-sidebar");
          });
        }
      }

      if (filterMoreButton === true) {
        $(document).find(".snize-product-filters-block").addClass("is-active");
        $(document)
          .find(".js-show-filters")
          .text("Less refinements")
          .addClass("is-active");
      }

      window.requestAnimationFrame(ss.filtersRaf);
    },
    initFilters: function () {
      window.requestAnimationFrame(this.filtersRaf);
      console.log('Filter Changed!');

      $(document).on("click", ".js-show-filters", (e) => {
        $(document)
          .find(".snize-product-filters-block")
          .toggleClass("is-active");
        $(e.currentTarget).toggleClass("is-active");

        if ($(e.currentTarget).hasClass("is-active")) {
          $(e.currentTarget).text("Less refinements");
          filterMoreButton = true;
        } else {
          $(e.currentTarget).text("More refinements");
          filterMoreButton = false;
        }
      });
    },
    initAutoSearch: function () {
      var currentAjaxRequest = null;

      $('#header form[action="/search"]').each(function () {
        var $form = $(this);
        console.log($form);
        $form.css("position", "relative");

        var $input = $form.find('input[name="q"]');
        var offSet = $input.position().top + $input.innerHeight();
        $('<ul class="box-results"></ul>')
          .css({ position: "absolute", top: offSet })
          .appendTo($form)
          .hide();

        $input.attr("autocomplete", "off").bind("keyup change", function () {
          var term = $(this).val();
          var $parent = $(this).closest("form");
          var resultsList = $parent.find(".box-results");
          var searchURL = "/search?type=product&q=" + term;
          if (
            $parent.find('[name="type"]').length &&
            $parent.find('[name="type"]').val() != "product"
          ) {
            searchURL =
              "/search?type=" +
              $parent.find('[name="type"]').val() +
              "&q=" +
              term;
          }

          if (term.length >= 3 && term != $(this).attr("data-old-term")) {
            $(this).attr("data-old-term", term);

            if (currentAjaxRequest != null) {
              currentAjaxRequest.abort();
            }

            currentAjaxRequest = $.getJSON(
              searchURL + "&view=json",
              function (data) {
                resultsList.empty();

                if (data.results_count == 0) {
                  resultsList.hide();
                } else {
                  $.each(data.results, function (index, item) {
                    var link = $("<a></a>").attr("href", item.url);
                    link.append(
                      '<div class="thumbnail"><img src="' +
                        item.thumbnail +
                        '" /></div>'
                    );
                    link.append(
                      '<h3 class="title_name">' +
                        item.title.split("[")[0] +
                        "</h3>"
                    );

                    if (item.description !== null) {
                      var longDecriptionS = item.description;
                      var shortDecriptionS =
                        longDecriptionS.slice(0, 50) + "...";
                      link.append(
                        '<p class="item_description">' +
                          shortDecriptionS +
                          "</p>"
                      );
                    } else {
                      link.append('<p class="item_description"></p>');
                    }

                    link.append('<p class="item_price">' + item.price + "</p>");
                    link.wrap("<li></li>");

                    resultsList.append(link.parent());
                  });

                  if (data.results_count > 5) {
                    resultsList.append(
                      '<li class="a-center"><span class="btn btn-results"><a href="' +
                        searchURL +
                        '"> All Results (' +
                        data.results_count +
                        ")</a></span></li>"
                    );
                  }
                  resultsList.fadeIn(200);
                }
              }
            );
          }
        });
      });

      $("body").bind("click", function () {
        $(".box-results").hide();
      });
    },
    unsetCookie: function (name) {
      document.cookie = name + "=; expires=Thu, 01 Jan 1970 00:00:01 GMT;";
    },
    setCookie: function (cname, cvalue, exdays) {
      var d = new Date();
      // console.log(d.getTime());
      d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
      var expires = "expires=" + d.toUTCString();

      document.cookie = cname + "=" + cvalue + "; " + expires + "; path=/";
    },
    getCookie: function (cname) {
      var name = cname + "=";
      var ca = document.cookie.split(";");

      for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == " ") c = c.substring(1);
        if (c.indexOf(name) == 0) return c.substring(name.length, c.length);
      }

      return "";
    },
    checkCookie: function () {
      var check_cookie = ss.getCookie("newsletter-wrapper");

      if (check_cookie == "") {
        ss.setCookie("newsletter-wrapper", "Newletter Popup", 1);
      }
    },
  };

  var theme = {
    initCollection: function () {
      console.log('Filter Applied!');
      /* Product Tag Filters - Good for any number of filters on any type of collection pages */
      $("body").on("click", "button#apply-sort-filter", function (e) {
        e.preventDefault();

        var arrFilterby = [];

        $("#ex2 input[type=checkbox].checked").each(function () {
          arrFilterby.push($(this).val());
        });

        var filterby = arrFilterby.join("+");
        var query = "";

        if (filterby != "") {
          query = "?constraint=" + filterby;
        }

        var newurl = "/collections/watches" + query;

        window.location.href = newurl;
      });
    },
    initBlog: function () {
      if ($("body").hasClass("template-article")) {
        // Image popup with zoom on Mobile
        $(".image-popup").magnifik();
      }

      // Sidebar & Overlay controls
      $(`body`)
        .on(`click`, `.open-sidebar, .sidebar-overlay`, function (e) {
          $(".sidebar-overlay").toggleClass("show");
          $(".sidebar-fixed").toggleClass("active");
        })

        .on(`click`, `.open-fiter`, function (e) {
          $(".sidebar-fixed").slideToggle(200);
          $(this).toggleClass("active");
        })

        .on(`click`, `#close-sidebar`, function (e) {
          $(".sidebar-overlay").removeClass("show");
          $(".sidebar-fixed").removeClass("active");
        });
    },
    initProduct: function () {
      this.productSubmitOffer();
      this.productImageSlider();

      /*
       * Attach events
       */
      $("body")
        /* jQueryModal Custom Options for Modal */
        .on("click", "a.enquiry-btn", function () {
          $(this).modal({
            fadeDuration: 250,
          });

          return false;
        })

        /* Question btn with Olark */
        .on("click", ".talk a", function (e) {
          e.preventDefault();
          $(".olark-launch-button").click();
        })

        /* Collapsable content for description */
        .on("click", ".sidebar-box .button", function () {
          var $el, $p, $up, $ps, totalHeight;

          totalHeight = 0;

          $el = $(this);
          $p = $el.parent();
          $up = $p.parent();
          $ps = $up.find("p:not('.read-more')");

          // measure how tall inside should be by adding together heights of all inside paragraphs (except read-more paragraph)
          $ps.each(function () {
            totalHeight += $(this).outerHeight();
          });

          $up
            .css({
              // Set height to prevent instant jumpdown when max height is removed
              height: $up.height(),
              "max-height": 9999,
            })
            .animate({
              height: totalHeight,
            });

          // fade out read-more
          $p.fadeOut();

          // prevent jump-down
          return false;
        })

        .on("click", ".tab-vertical > ul > li", function () {
          $(".tab-vertical>ul>li").removeClass("active");
          $(this).addClass("active");
        });

      /*
       *
       */
      var timer;
      var winW = $(window).width();
      $(window)
        .on("resize.refreshSlick", function () {
          clearTimeout(timer);

          timer = setTimeout(function () {
            var curW = $(window).width();

            if (curW >= 768 && winW < 768) {
              $(".slider-for").slick("unslick");
              $(".slider-nav").slick("unslick");
              $(".slider-nav").find(".slick-list").removeAttr("style");
              $(".slider-nav").find(".slick-track").removeAttr("style");
              $(".slider-nav").find(".slick-slide").removeAttr("style");
              $(".slider-nav").find("button.slick-arrow").remove();

              theme.productImageSlider();
            }

            winW = curW;
          }, 500);
        })
        .on("load", function () {
          theme.productImageSlider();

          if ($(window).width() >= 992 && $(".zoomContainer").length === 0) {
            /*$(".fancybox").fancybox();*/

            var zoomOptions = {
              cursor: "crosshair",
              galleryActiveClass: "active",
              imageCrossfade: false,
              scrollZoom: false,

              onImageSwapComplete: function () {
                $(".zoomWrapper div").hide();
              },
              loadingIcon: window.loading_url,
            };

            $(".slider-for .slick-current img").elevateZoom(zoomOptions);

            $(".slider-for").on(
              "beforeChange",
              function (event, slick, currentSlide, nextSlide) {
                $.removeData(currentSlide, "elevateZoom");
                $(".zoomContainer").remove();
              }
            );

            $(".slider-for").on("afterChange", function () {
              $(".slider-for .slick-current img").elevateZoom(zoomOptions);
            });
          }
        });
    },
    productSubmitOffer: function () {
      var form = document.getElementById("submitOfferForm");

      if (form) {
        form.addEventListener("submit", function (ev) {
          ev.preventDefault();
          $.ajax({
            url: form.action,
            data: new FormData(form),
            method: "POST",
            type: "POST",
            contentType: false,
            processData: false,
            dataType: "json",
            success: function () {
              // $('.form-controls').replaceWith('<div id="form-status" class="form-status__success">The form was submitted successfully</div>')
              window.location.href = "/pages/successfully-submitted-an-offer";
            },
            error: function (err) {
              $(".form-controls").replaceWith(
                '<div id="form-status" class="bg-danger form-status__success">Something went wrong.</div>'
              );
              console.log(err);
            },
          });
        });
      }
    },
    productImageSlider: function () {
      if (
        !$(".slider-for").hasClass("slick-initialized") &&
        !$(".slider-nav").hasClass("slick-initialized")
      ) {
        $(".slider-for").slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          nextArrow: '<div class="slick-next"><i class="icon-right"></i></div>',
          prevArrow: '<div class="slick-prev"><i class="icon-left"></i></div>',
          fade: window.innerWidth < 768 ? false : true,
          accessibility: false,
          verticalSwiping: false,
          arrows: false,
          dots: window.innerWidth < 768 ? true : false,
          asNavFor: ".slider-nav",
        });

        var config = {
          infinite: false,
          slidesToShow: 4,
          slidesToScroll: 1,
          asNavFor: ".slider-for",
          verticalSwiping: true,
          dots: false,
          accessibility: false,
          focusOnSelect: true,
          arrows: true,
          nextArrow:
            '<div class="slick-next" style="top: -30px;left: 35px;position: relative;"><i class="fa fa-angle-down color-333"></i></div>',
          prevArrow:
            '<div class="slick-prev" style="left: 34px;top: -33px;"><i class="fa fa-angle-up color-333"></i></div>',
          responsive: [
            {
              breakpoint: 1200,
              settings: {
                slidesToShow: 5,
                slidesToScroll: 1,
              },
            },
            {
              breakpoint: 1224,
              settings: {
                slidesToShow: 5,
                slidesToScroll: 1,
              },
            },
            {
              breakpoint: 1025,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 1,
              },
            },

            {
              breakpoint: 767,
              settings: {
                slidesToShow: 4,
                slidesToScroll: 2,
                dots: false,
              },
            },
            {
              breakpoint: 421,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 2,
                dots: false,
              },
            },
            {
              breakpoint: 321,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 2,
                dots: false,
              },
            },
          ],
        };

        var $imageContainer = $(".product-media");
        var pt_position = "left";
        if ($imageContainer.hasClass("thumbnail-right")) {
          pt_position = "right";
        } else if ($imageContainer.hasClass("thumbnail-bottom")) {
          pt_position = "bottom";
        }

        // Update Slider direction
        if (pt_position != "bottom") {
          config.vertical = true;
        }

        // Update Slider nav buttons
        if (pt_position == "bottom") {
          config.nextArrow =
            '<div class="slick-next"><i class="fa fa-arrow-right"></i></div>';
          config.prevArrow =
            '<div class="slick-prev"><i class="fa fa-arrow-left"></i></div>';

          config.responsive = [
            {
              breakpoint: 1200,
              settings: {
                slidesToShow: 5,
                slidesToScroll: 1,
              },
            },
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 5,
                slidesToScroll: 1,
              },
            },
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 4,
                slidesToScroll: 1,
                dots: false,
              },
            },
            {
              breakpoint: 321,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 2,
                dots: false,
              },
            },
          ];
        }

        var productSliderNav = $(".slider-nav").slick(config);

        if (window.innerWidth < 768) {
          productSliderNav.css("display", "none");
        }
      }
    },
  };

  /*
   * Document Ready event
   */
  $(document).ready(function () {
    ss.init();

    if (window.show_multiple_currencies) {
      var shopCurrency = window.shop_currency;
      Currency.format = "money_format";
      Currency.moneyFormats[shopCurrency].money_with_currency_format =
        window.money_with_currency_format_currency;
      Currency.moneyFormats[shopCurrency].money_format =
        window.money_format_currency;

      var cookieCurrency = ss.getCookie("currency");

      $("span.money span.money").each(function () {
        $(this).parent("span.money").removeClass("money");
      });

      $("span.money").each(function () {
        $(this).attr(`data-currency-${shopCurrency}`, $(this).html());
      });

      var currencySwitcher = $("select[name=currencies]");
      // When the page loads.
      if (cookieCurrency == null || cookieCurrency == shopCurrency) {
        Currency.currentCurrency = shopCurrency;
      } else {
        Currency.currentCurrency = cookieCurrency;
        currencySwitcher.val(cookieCurrency);
        Currency.convertAll(shopCurrency, cookieCurrency);
      }

      currencySwitcher.change(function () {
        ss.unsetCookie("currency");
        var newCurrency = $(this).val();
        ss.setCookie("currency", newCurrency, 30);
        Currency.convertAll(Currency.currentCurrency, newCurrency);
      });

      $("body").on("ajaxCart.afterCartLoad", function (cart) {
        Currency.convertAll(shopCurrency, $("select[name=currencies]").val());
      });
    }

    // Collection page template
    if ($("body").hasClass("template-collection")) {
      theme.initCollection();
    }

    // Blog or Article page templates
    if (
      $("body").hasClass("template-blog") ||
      $("body").hasClass("template-article")
    ) {
      theme.initBlog();
    }

    // Product page template
    if ($("body").hasClass("template-product")) {
      theme.initProduct();
    }

    // Add events
    $("body")
      .on(`focus`, `.form-control`, function () {
        var $form = $(this).closest("form");
        $form.css("borderColor", "#CFC99E");
      })

      .on(`focusout`, `.form-control`, function () {
        var $form = $(this).closest("form");
        $form.css("borderColor", "");
      })

      .on(`change`, `input[name='hidden-popups']`, function () {
        if ($(this).is(":checked")) {
          ss.checkCookie();
        } else {
          ss.unsetCookie("newsletter-wrapper");
        }
      })

      .on(`click`, `.ss_newletter_custom_popup_bg`, function () {
        $("body").removeClass("hidden-scorll");
        $("#popup-newletter").hide();
      })

      .on(`click`, `.popup-close`, function () {
        $("body").removeClass("hidden-scorll");
        $("#popup-newletter").hide();
      });
  });

  /*
   * KeyUp press event
   */
  $(document).keyup(function (e) {
    if (e.keyCode == 27) {
      ss.hidePopup();
    }
  });

  /*
   * Scroll event
   */
  // $(window).scroll(function () {
  //   if ($(this).scrollTop() >= 36) {
  //     $(".header.header-fixed").addClass("stickytop");
  //     $(".header.header-fixed .header-bottom .container").addClass(
  //       "border-bottom-hide"
  //     );
  //   } else {
  //     $(".header.header-fixed").removeClass("stickytop");
  //     $(".header.header-fixed .header-bottom .container").removeClass(
  //       "border-bottom-hide"
  //     );
  //   }
  // });

  /*
   * Cookies for system message
   */
  // $(window).load(function () {
  //   // if no cookie
  //   if ($.cookie("alert") != "true") {
  //     $("#system-message").show();

  //     $(document.body).addClass("with-message");

  //     $("#close").click(function () {
  //       $("#system-message").slideUp(0);

  //       $(document.body).removeClass("with-message");

  //       // set the cookie for 24 hours
  //       var date = new Date();
  //       date.setTime(
  //         date.getTime() + window.message_expireday * 24 * 60 * 60 * 1000
  //       );
  //       $.cookie("alert", "true", {
  //         expires: date,
  //       });
  //     });
  //   }

  //   // Newsletter
  //   var check_cookie = ss.getCookie("newsletter-wrapper");
  //   if (check_cookie != "") {
  //     $("#popup-newletter").hide();
  //     $("#popup-newletter").removeClass("show");
  //     return;
  //   } else {
  //     $("#popup-newletter").show();
  //     $("body").addClass("hidden-scorll");
  //     $("#popup-newletter").addClass("popup_bgs");
  //   }
  // });
})(jQuery);
